module.exports = __webpack_public_path__ + "static/media/icn_works_60x60.de10f34e.svg";